export const DataGrid = {
  MuiDataGrid: {
    styleOverrides: {
      root: {
        borderRadius: '8px',
        letterSpacing: '.17px',
        '& .MuiSelect-select': {
          paddingRight: '30px !important',
        },
        '& .MuiDataGrid-menuIcon': {
          marginRight: 5,
        },
        '.MuiDataGrid-cell': {
          cursor: 'pointer',
        },
        '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
          outline: 'none !important',
        },
        '& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator': {
          display: 'none',
        },
        '& .MuiDataGrid-row--lastVisible .MuiDataGrid-cell': {
          borderBottom: 'none',
        },
      },
    },
  },
};
